import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import ChangePassword from "@/Components/common/client/profile/ChangePassword";
import ClientContactProfile from "@/Components/common/client/profile/ClientContactProfile";
import { ClientProfile } from "@/Components/common/client/profile/ClientProfile";
import { updateactivePages } from "@/reducers/clientcommon";
import {
  fetchClientContactProfile,
  fetchClientProfile,
} from "@/reducers/clientprofile";

import useTitle from "../../utilities/hooks/useTitle";

/**
 * Functional component for rendering user profile.
 *
 * @return {JSX.Element} the JSX element representing the user profile
 */
const Profile = () => {
  useTitle("Profile");
  const fetchAllfields = () => {
    // all_region
    // all_sector
    // all_ccg_group
    // all_it_system
    // all_county
    // all_regions_from_county
    // $data['is_main_client'] = Session::get('is_main_client');
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      updateactivePages({
        activePage: "dashboard",
        activeSubPage: null,
      }),
    );
    dispatch(fetchClientContactProfile());
    dispatch(fetchClientProfile());
  }, []);
  return (
    <div className="flex flex-col gap-6">
      <ClientContactProfile />
      <ClientProfile />
      <ChangePassword />
    </div>
  );
};

export default Profile;
